import { SourcePlate } from "../models-new/sourcePlate";
import {Plate} from '../models-new/plate';

export class PlateScanValue{
	scanValue: string;
	primaryPlateID: string;
	hasSourcePlates = false;
	sourcePlates: Array<SourcePlate> = [];
}

export class MultiQcUpdateDTO{
	labID: string;
	puid: string;
	redoConfigurations: any = {};
	plateRedoSelections: any = {};
	scannedPlates: any = {};
	mappedRedoPlates: Array<RedoPlateInformation> = [];
	associatedArrays: any = {};
	processStepName: string;
	actionName: string;
}

export class RedoPlateInformation {
    currentPlateID = "";
    sourcePlateInformations: Array<RedoSourcePlateInformation> = [];
}

export class RedoSourcePlateInformation {
    sourcePlateID = "";
    sourcePlates: Array<string> = [];
}

export class QCFailPlateDetailsResponse {
    plateDetailDTO: Plate;
    scannedPlates: Map<string, Plate>;
    mappedRedoPlate: RedoPlateInformation;
    associatedArrays: Map<string, Array<Plate>>;
}